import { render, staticRenderFns } from "./editPeopleNumber.vue.js?vue&type=template&id=8bc91862&scoped=true!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./editPeopleNumber.vue?vue&type=template&id=8bc91862&scoped=true"
import script from "./editPeopleNumber.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./editPeopleNumber.vue?vue&type=script&lang=js"
export * from "./editPeopleNumber.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./editPeopleNumber.vue?vue&type=script&lang=js"
import style0 from "./editPeopleNumber.vue.scss?vue&type=style&index=0&id=8bc91862&lang=scss&scoped=true!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./editPeopleNumber.vue?vue&type=style&index=0&id=8bc91862&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc91862",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/web-hok_Mssh/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bc91862')) {
      api.createRecord('8bc91862', component.options)
    } else {
      api.reload('8bc91862', component.options)
    }
    module.hot.accept("./editPeopleNumber.vue.js?vue&type=template&id=8bc91862&scoped=true!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./editPeopleNumber.vue?vue&type=template&id=8bc91862&scoped=true", function () {
      api.rerender('8bc91862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/live/liveRoom/components/Dialog/editPeopleNumber.vue"
export default component.exports